import { StyledModal } from '@app/components/modal/Modal';
import useBrandActions from '@app/hooks/brands/useBrandActions';
import type { Brand } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import { BrandForm } from './BrandForm';

export type BrandEditModalProps = ModalProps & {
    title?: string;
    data?: Brand;
    showFooter?: boolean;
};

export const BrandEditModal = ({
    title = 'Edit Brand',
    data,
    onOk,
    ...props
}: BrandEditModalProps) => {
    const { editBrand } = useBrandActions();

    return (
        <StyledModal title={title} mask={{ closable: false }} width={680} footer={null} {...props}>
            <BrandForm
                id="brand-edit"
                data={data}
                isEdit={true}
                onCancel={props.onCancel}
                loading={editBrand.isPending}
                // showFooter={false}
                onSubmit={(values) => {
                    const userId = data?.id?.toString() || '';
                    const formData = {
                        ...values,
                        id: userId,
                    };
                    editBrand.mutate(formData, {
                        onSuccess: () => {
                            if (onOk) {
                                onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                            }
                        },
                    });
                }}
            />
        </StyledModal>
    );
};
